import * as React from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { imageError } from '../utils/imageError';
import { DataStore } from '../stores';
import Icon from './Icon';

const ImageContainer = styled<any, any>('div')`
    ${propStyles};
    overflow: hidden;
    position: relative;
    flex-shrink: 0;
`;

ImageContainer.defaultProps = {
    alignSelf: 'center',
    display: 'block',
    height: ['80px', '120px'],
    width: ['80px', '120px'],
    marginY: ['sm', '0'],
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'gray300',
    borderRadius: '120px',
    bgColor: 'gray100',
};

const Image = styled<any, any>('img')`
    ${propStyles};
    position: relative;
    z-index: 1;
    overflow: hidden;
    text-indent: -100em; /* hides alt text */
`;

Image.defaultProps = {
    display: 'block',
    width: '100%',
};

interface FundManagerImage {
    theme?: any;
    dataStore?: DataStore;
    name: string;
    code: string;
}

const FundManagerImage: React.SFC<FundManagerImage> = ({
    theme,
    dataStore,
    name,
    code,
}) => (
    <ImageContainer {...theme.FundManagerImage}>
        <Image
            src={`${
                dataStore.baseUrl
            }/fund/fundmanagerpicture?code=${code}&token=${dataStore.token}`}
            alt={name}
            onError={e => imageError(e.target)}
        />
        <Icon
            fileName="FundManagerPlaceholder"
            display="block"
            height="100%"
            width="100%"
            {...theme.FundManagerPlaceholderImage}
        />
    </ImageContainer>
);

export default inject('dataStore')(observer(withTheme(FundManagerImage)));



// WEBPACK FOOTER //
// ./src/Components/FundManagerImage.tsx